import { FC, forwardRef, ForwardedRef } from 'react';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { CaretPosition } from '../Button/Button.types';
import { StyledLink } from './Link.styles';
import { LinkProps } from './Link.types';

const Link: FC<LinkProps> = forwardRef(({ caret, label, to, dataTestId, target = '_self', ...props }, ref: ForwardedRef<HTMLAnchorElement>) => {
  return (
    <StyledLink {...props} caret={caret} ref={ref} to={to} data-testid={dataTestId ? dataTestId : 'TextLink'} target={target}>
      {caret === CaretPosition.Left && <ChevronLeftOutlinedIcon />}
      {label}
      {caret === CaretPosition.Right && <ChevronRightOutlinedIcon />}
    </StyledLink>
  );
});

export default Link;
